import React from "react";

function NewFillCloseIcon() {
  return (
    <svg style={{ color: 'var(--brand, #365d7e)' }}       width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.665 13.33C10.3483 13.33 13.33 10.3483 13.33 6.665C13.33 2.98171 10.3483 0 6.665 0C2.98171 0 0 2.98171 0 6.665C0 10.3483 2.98171 13.33 6.665 13.33ZM4.05513 4.80582C3.85167 4.60236 3.85167 4.2656 4.05513 4.06214C4.25858 3.85868 4.59534 3.85868 4.7988 4.06214L6.665 5.92133L8.5312 4.05513C8.73466 3.85167 9.07142 3.85167 9.27487 4.05513C9.47833 4.25858 9.47833 4.59534 9.27487 4.7988L7.40867 6.665L9.27487 8.5312C9.47833 8.73466 9.47833 9.07142 9.27487 9.27487C9.16964 9.38011 9.03634 9.42922 8.90304 9.42922C8.76974 9.42922 8.63644 9.38011 8.5312 9.27487L6.665 7.40867L4.7988 9.27487C4.69356 9.38011 4.56026 9.42922 4.42696 9.42922C4.29366 9.42922 4.16036 9.38011 4.05513 9.27487C3.85167 9.07142 3.85167 8.73466 4.05513 8.5312L5.92133 6.665L4.05513 4.80582Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default NewFillCloseIcon;
